import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';

import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, LoadingService, UserService } from '@core/services';
import { User } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-renewal-amount',
  templateUrl: './renewal-amount.component.html',
  styleUrls: ['./renewal-amount.component.css'],
  animations: [fadeAnimation]
})
export class RenewalAmountComponent implements OnInit, OnDestroy {

  renewalForm: FormGroup;
  subscription: Subscription;
  user: User;

  private oldRenewalAmount = 0;
  private minimumAmount = 20;

  constructor(private _userService: UserService,
              private _authGuard: AuthGuardService,
              private dialog: MatDialog,
              private _loadingService: LoadingService) {
    this.renewalForm = new FormGroup({
      newRenewalAmount: new FormControl()
    });

  }

  ngOnInit() {
    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(): boolean{
    let renewalData = this.setUpChangeRenewalData();

    // If they didnt make first payment yet they cant change renewal amount
    if(this.user.accountSummaryArray[this.user.accountIndex].AccountBalance === 0 && 
      this.user.accountSummaryArray[this.user.accountIndex].NumberOfTrips === 0) 
    {
      let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            message: "You must make your first payment before you are able to change your renewal amount.",
              alertType: 'primary',
              title: 'No Initial Payment'
          }
      });
      return false;
    }


    if(renewalData.RenewalAmount < this.minimumAmount){

                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                      message: "The minimum renewal amount is " + this.formatMoneyString(this.minimumAmount),
                        alertType: 'primary',
                        title: 'Renewal Amount Too Low'
                    }
                });
      return false;
    }

    this._loadingService.showLoader(); // Show loader for submit

    this._authGuard.authenticatedPost('/portfolios/ChangeRenewalAmount', renewalData).subscribe(
      result => {
                let dialogRef = this.dialog.open(ResultDialogComponent, {
                    data: {
                        message: "You have successfully updated your renewal amount",
                        alertType: 'success',
                        title: 'Updated Renewal Amount'
                    }
                });
        this._loadingService.hideLoader(); // hide loader on success
        this.oldRenewalAmount = renewalData.RenewalAmount;
        this.user.accountSummaryArray[this.user.accountIndex].ReplenishmentAmount = renewalData.RenewalAmount;
        console.log('Change Renewal Amount result:', result);
        return true;
      },
      error => {
        console.log('Change Renewal Error:', error);
        this._loadingService.hideLoader(); // hide loader on error
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data:{
            message: "We could not update your renewal amount, " + error,
            alertType: 'danger',
            title: 'Failed to Update Renewal Amount'
        }
                                                                });
        return false;
      }
    );
  }

  public updateAccount(accountEvent){
    console.log(accountEvent);
    this.oldRenewalAmount = this.user.accountSummaryArray[this.user.accountIndex].ReplenishmentAmount;
  }

  private setUpChangeRenewalData() {
    console.log(this.renewalForm.value);

    return {
      'Email': this.user.email,
      'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id,
      'RenewalAmount': this.renewalForm.value.newRenewalAmount
    };
  }

  private formatMoneyString(renewalAmount: number){
    return renewalAmount.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/renewal-amount/renewal-amount.component.ts